import { render, staticRenderFns } from "./MigrateProjectComponent.vue?vue&type=template&id=677d1632&scoped=true"
import script from "./MigrateProjectComponent.vue?vue&type=script&lang=js"
export * from "./MigrateProjectComponent.vue?vue&type=script&lang=js"
import style0 from "./MigrateProjectComponent.vue?vue&type=style&index=0&id=677d1632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677d1632",
  null
  
)

export default component.exports